var $ = require("jquery");

export const mvAnimation = () => {
  if ($(".js-mv-animation").length !== 0) {
    $("body").addClass("is-mv-animated");
  }
};
